import { render, staticRenderFns } from "./UkrposhtaCreationSection.vue?vue&type=template&id=17e13245"
import script from "./UkrposhtaCreationSection.vue?vue&type=script&lang=js"
export * from "./UkrposhtaCreationSection.vue?vue&type=script&lang=js"
import style0 from "./UkrposhtaCreationSection.vue?vue&type=style&index=0&id=17e13245&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports